import { Box, BoxProps, Button, Menu, MenuButton, MenuDivider, MenuGroup, MenuItem, MenuList } from "@chakra-ui/react";
import { useDeepAuth } from "components/api";
import { useState } from "react";
import { FaBolt, FaChevronDown, FaChevronRight, FaShieldAlt, FaSkull, FaUserEdit, FaUserSecret } from "react-icons/fa";
import { useVVStore } from "./store";


export interface AdminMenuProps extends BoxProps {

}

export function AdminMenu({ children, ...rest }: AdminMenuProps) {
    const auth = useDeepAuth();
    //const [isOpen, setIsOpen] = useState(false)
    if (!auth.signedUser?.isAdmin)
        return <></>;

    return <Menu //isOpen={isOpen} onClose={() => setIsOpen(false)} 
    >
        <MenuButton as={Button} variant='outline' colorScheme='red' size='xs' rightIcon={<FaChevronDown />} >Admin</MenuButton>
        <MenuList>
            {children}
        </MenuList>
    </Menu>



}



export function AdminSubMenu({ label, children, icon }: { label: string; children: React.ReactNode, icon?: React.ReactElement }) {
    const [open, setOpen] = useState(false);
    const isMobile = useVVStore(state => state.isMobile());
    if (isMobile) {
        return <>
            <MenuDivider />
            <MenuGroup title={label}>
                {children}
            </MenuGroup>
        </>
    }

    return (
        <Box position="relative"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(v => !v) }}
            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
            onTouchEnd={e => { e.preventDefault(); e.stopPropagation(); }}
        >
            <MenuItem icon={icon} >
                <Box display='flex' flexDir='row' flexWrap='nowrap' justifyContent="space-between" whiteSpace='nowrap' alignItems='center'>
                    {label} <FaChevronRight />
                </Box>
            </MenuItem>
            {open && (
                <MenuList position="absolute" left="100%" top="0" zIndex="popover">
                    {children}
                </MenuList>
            )}
        </Box>
    );
}
